import { industryTags } from './industryTags'
import { STATIC_OBS_URL } from '../../consts'

import type { PageContent } from '..'

export const industryList: PageContent[] = [
  // 航发
  {
    id: '134-1.html',
    tag: industryTags[0].name,
    tagId: industryTags[0].id,
    title: '涡轴发动机模型',
    descriptions:
      '飞机涡轴发动机包含压气机、燃烧室、高压涡轮、低压动力涡轮。采用GCKontrol对飞机涡轴发动机建模，完成系统仿真，可对系统的动态响应、稳态响...',
    thumbnail: `${STATIC_OBS_URL}/website/home/industry/l1.jpg`
  },
  {
    id: '134-2.html',
    tag: industryTags[0].name,
    tagId: industryTags[0].id,
    title: '飞发一体化综合仿真',
    descriptions:
      '本案例构建飞发一体化综合仿真系统，建立了全包线，用于评估发动机性能、噪音、排放和安全性，并利用三维视景技术动态显示飞机的飞行场景，最...',
    thumbnail: `${STATIC_OBS_URL}/website/home/industry/l2.jpg`
  },
  // 航空
  {
    id: '133-1.html',
    tag: industryTags[1].name,
    tagId: industryTags[1].id,
    title: '机电液执行机构',
    descriptions:
      '广泛应用于飞机的各类舵机和操纵系统。用GCKontrol构建液压部件模型和液压系统模型实现对系统动态响应、稳态响应和系统总体性能的分析。',
    thumbnail: `${STATIC_OBS_URL}/website/home/industry/l3.jpg`
  },
  {
    id: '133-2.html',
    tag: industryTags[1].name,
    tagId: industryTags[1].id,
    title: '数字孪生飞机起落架虚实融合平台',
    descriptions:
      '本案例虚实融合平台由GCAir和相关参试设备组成，参试设备包括起落架、控制单元、模拟器等，其中模拟器用于人机交互。基于GCAir仿真测试验证一体化平...',
    thumbnail: `${STATIC_OBS_URL}/website/home/industry/l4.jpg`
  },
  {
    id: '133-3.html',
    tag: industryTags[1].name,
    tagId: industryTags[1].id,
    title: '无人机飞行控制与管理系统适航性测试验证',
    descriptions:
      '采用GCKontrol+GCAir+TestManager全面工具链，完成了无人机试验综合管理系统，该系统硬件参测设备包括六部分：加速度转台、大气模拟器、角速度转台、卫星导航模拟器、地面站、飞控计算机。本案例完成了总体系统设计、多源异构系统集成，参测设备、激励设备硬件集成，完成了系统总体的半实物仿真，三维视景和数字孪生。并完成了自动化批量测试，自动化测试报告生成。',
    thumbnail: `${STATIC_OBS_URL}/website/home/industry/l5.jpg`
  },

  // 航天
  {
    id: '132-1.html',
    tag: industryTags[2].name,
    tagId: industryTags[2].id,
    title: '卫星姿轨模型',
    descriptions:
      '卫星姿态控制系统由敏感器、控制逻辑单元（控制器）、执行和动力学模块组成。敏感器确定卫星姿态；控制器使电信号以正确顺序发送到力矩输出单...',
    thumbnail: `${STATIC_OBS_URL}/website/home/industry/l6.jpg`
  },
  {
    id: '132-2.html',
    tag: industryTags[2].name,
    tagId: industryTags[2].id,
    title: '数字卫星仿真平台和伴飞系统',
    descriptions:
      '数字卫星仿真平台和伴飞系统实现了定制开发数字卫星模板库，内嵌了数字航天器建模标准；在轨航天器故障推演和故障仿真；空间态势信息与空间任务三...',
    thumbnail: `${STATIC_OBS_URL}/website/home/industry/l7.jpg`
  },
  // 汽车
  {
    id: '131-1.html',
    tag: industryTags[3].name,
    tagId: industryTags[3].id,
    title: '汽车控制应用层开发',
    descriptions:
      '本系统以新能源汽车为研究对象，用GCKontrol搭建系统模型。该系统包括驾驶员(Driver)、整车控制器(VCU)、汽车电子稳定控制系统(ESC)、发动机阻力...',
    thumbnail: `${STATIC_OBS_URL}/website/home/industry/l8.jpg`
  },
  {
    id: '131-2.html',
    tag: industryTags[3].name,
    tagId: industryTags[3].id,
    title: '汽车整车控制器VCU硬件在环(HiL)仿真测试和验证',
    descriptions:
      '本案例实现新能源整车控制器VCU的硬件在环仿真测试和验证。搭建GCAir工程：1.车辆子系统做为被控...',
    thumbnail: `${STATIC_OBS_URL}/website/home/industry/l9.jpg`
  },
  {
    id: '131-3.html',
    tag: industryTags[3].name,
    tagId: industryTags[3].id,
    title: 'TCU AUTOSAR功能配置与代码生成',
    descriptions:
      '本案例以TCU为研究对象，利用世冠科技GCKontrol的AUTOSAR功能进行配置，包括AUTOSAR字典、AUTOSAR映射和AUTOSAR代码生成。AUTOSAR字典可配置原子组件、S-R接口、收发端口、运行实体及事件类型等，AUTOSAR映射可以将AUTOSAR字典与GCK工程模型进行映射配置，支持基本运算、状态图、插值表等。GCKontrol可生成的符合AUTOSAR规范的arxml、C-code等。',
    thumbnail: `https://static-download.globalcrown.com.cn/website/pictures/mtky6cib-329064573f0d4ce9.png`
  }
]
